// Capability band scale — mirrors agent/scoring-config.json and design/README.md.
// Band identity ALWAYS pairs the label with the swatch (never colour alone) — a11y.

export type BandKey = 'early_stage' | 'developing' | 'capable' | 'advanced' | 'transformative';

export interface BandDef {
  key: BandKey;
  label: string;
  level: number;
  fill: string;
  text: string;
  descriptor: string;
}

export const BANDS: BandDef[] = [
  { key: 'early_stage', label: 'Early Stage', level: 1, fill: '#6E7180', text: '#FFFFFF', descriptor: 'Just getting started with AI in your work.' },
  { key: 'developing', label: 'Developing', level: 2, fill: '#2438E6', text: '#FFFFFF', descriptor: 'Using AI for some tasks, building confidence.' },
  { key: 'capable', label: 'Capable', level: 3, fill: '#B52CF2', text: '#FFFFFF', descriptor: 'Applying AI reliably across familiar work.' },
  { key: 'advanced', label: 'Advanced', level: 4, fill: '#C2FF01', text: '#000000', descriptor: 'Designing AI into workflows with judgement.' },
  { key: 'transformative', label: 'Transformative', level: 5, fill: '#00D700', text: '#000000', descriptor: 'Reshaping how work is done with AI.' },
];

export const bandByKey = (k: BandKey): BandDef => BANDS.find((b) => b.key === k) ?? BANDS[0];

// 4D status chips (light)
export const FOURD_STATUS = {
  strong: { label: 'Strong', fill: '#E8F9E8', text: '#0A7A0A' },
  in_place: { label: 'In place', fill: '#EAEDFF', text: '#2438E6' },
  emerging: { label: 'Emerging', fill: '#F0F0F2', text: '#75757F' },
} as const;

export const SEVERITY = {
  high: { label: 'High', fill: '#E5142B', text: '#FFFFFF' },
  medium: { label: 'Medium', fill: '#C2FF01', text: '#000000' },
  low: { label: 'Low', fill: '#C8C8CC', text: '#000000' },
} as const;

const MMM = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

// DD MMM YYYY (Australian English). Deterministic — not locale/ICU dependent.
export function formatDate(iso?: string): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const dd = String(d.getUTCDate()).padStart(2, '0');
  return `${dd} ${MMM[d.getUTCMonth()]} ${d.getUTCFullYear()}`;
}
